import type { SpinSlotResponse } from '@goodtime/shared';

/**
 * How App reaches the story without a hook of its own: {@link SlotStory}
 * (mounted by App on a story slot) fills these in; with no story they do
 * nothing. Plain fields, so App can call them from its spin and exit paths.
 */
export const storyBridge = {
  /** A spin's response, as the reels land. */
  onSpinLanded: (_response: SpinSlotResponse): void => {},
  /** The reels are idle. */
  onSlotIdle: (): void => {},
  /** Leaving the slot: resolves false to stay (the takings card). */
  beforeExit: async (): Promise<boolean> => true,
  /** True while a beat or a story card is on screen. */
  busy: (): boolean => false,
  /** The player opened the daily bonus from the map: the plain card shows
   *  it, rather than the morning card on the slot. */
  dailyReleased: false,
};

/** Back to doing nothing (the story slot closed). */
export function resetStoryBridge(): void {
  storyBridge.onSpinLanded = () => {};
  storyBridge.onSlotIdle = () => {};
  storyBridge.beforeExit = async () => true;
  storyBridge.busy = () => false;
}
